// src/utils/api.ts
import { createClient } from "@connectrpc/connect";
import { createConnectTransport } from "@connectrpc/connect-web";
import type { Client, Interceptor } from "@connectrpc/connect";

/**
 * Interceptor para adicionar o token de autenticação em cada requisição.
 * Ele lê o token diretamente do localStorage para evitar problemas de
 * dependência circular ou de ciclo de vida com o store do Pinia.
 */
const authInterceptor: Interceptor = (next) => async (req) => {
  const token = localStorage.getItem("accessToken");

  if (token) {
    req.header.set("Authorization", `Bearer ${token}`);
  }

  return await next(req);
};

// URL da sua API. Pode ser movida para variáveis de ambiente (.env).
export const apiUrl = "https://api.cashbroker.cash/";

// Cria o transporte base para todas as chamadas da API.
export const transport = createConnectTransport({
  baseUrl: apiUrl,
  interceptors: [authInterceptor],
});

// CORREÇÃO: Inferimos o tipo de descrição de serviço (`DescService`) diretamente
// do primeiro parâmetro da função `createClient`. Esta é a abordagem mais robusta.
type DescService = Parameters<typeof createClient>[0];

// Tipo genérico para o cliente de serviço, usando o tipo inferido.
export type ApiClient<T extends DescService> = Client<T>;

/**
 * Função genérica para criar um cliente de API para um serviço específico.
 * Esta é a central única para criar clientes de API.
 * @param service - A definição do serviço do connectRPC (ex: AuthService, UserService).
 * @returns Um cliente de API tipado e pronto para uso.
 */
export function createApiClient<T extends DescService>(
  service: T,
): ApiClient<T> {
  return createClient(service, transport);
}
export function apiClient(service: any): Client<any> {
  return createClient(service, transport);
}
